// import PropTypes from "prop-types";
import { MuiThemeProvider } from "@material-ui/core/styles";
import React, { Component } from "react";
import App from "./App";
// views
import Login from "./Login";
// notifications
import NotificationContainer from "./library/notifications/NotificationContainer";
import NotificationManager from "./library/notifications/NotificationManager";
import "./library/notifications/notifications.css";
// services
import Caba from "./services/Caba";
import { theme } from "./theme";

// clientId
const clientId =
  "79318368545-kt8pdft7a7vieo5e5s5v1312s84772r1.apps.googleusercontent.com";

export default class Container extends Component {
  static propTypes = {};
  constructor(props) {
    super(props);
    this.state = {
      isLoggedIn: false
    };

    Caba.notify = this.notify;
  }

  setLogin = isLoggedIn => {
    this.setState({ isLoggedIn });
  };

  notify = (type, title, message, duration = 5000, callback) => {
    switch (type) {
      case "info":
        NotificationManager.info(message, title, duration, callback);
        break;
      case "success":
        NotificationManager.success(message, title, duration, callback);
        break;
      case "warning":
        NotificationManager.warning(message, title, duration, callback);
        break;
      case "error":
        NotificationManager.error(message, title, duration, callback);
        break;
      default:
        break;
    }
  };

  render() {
    const { isLoggedIn } = this.state;

    // content
    let content = (
      <Login
        clientId={clientId}
        setLogin={this.setLogin}
        notify={this.notify}
      />
    );
    if (isLoggedIn)
      content = (
        <App
          notify={this.notify}
          Caba={this.Caba}
          gTemplate={this.gTemplate}
          setLogin={this.setLogin}
        />
      );

    return (
      <MuiThemeProvider theme={theme}>
        <NotificationContainer />
        {content}
      </MuiThemeProvider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Container.js